import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-auto px-20 pb-8" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_3 = { class: "py-10 flex justify-between" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4" }
const _hoisted_6 = { class: "lg:col-span-2" }
const _hoisted_7 = { class: "grid lg:grid-cols-2 gap-3" }
const _hoisted_8 = { class: "flex flex-col pb-3" }
const _hoisted_9 = { class: "flex flex-col pb-3" }
const _hoisted_10 = { class: "flex flex-col pb-3 lg:border-b border-next-gray-md-dark" }
const _hoisted_11 = { class: "flex flex-col pb-3 border-b border-next-gray-md-dark" }
const _hoisted_12 = { class: "flex flex-col pb-3" }
const _hoisted_13 = { class: "flex flex-col pb-3" }
const _hoisted_14 = { class: "flex flex-col pb-3 lg:border-b border-next-gray-md-dark" }
const _hoisted_15 = { class: "grid grid-cols-4 gap-3" }
const _hoisted_16 = { class: "flex flex-col pb-3 lg:border-b border-next-gray-md-dark" }
const _hoisted_17 = { class: "grid grid-cols-4 gap-3" }
const _hoisted_18 = { class: "flex flex-col pb-3 lg:border-b border-next-gray-md-dark" }
const _hoisted_19 = { class: "flex flex-col pb-3 lg:border-b border-next-gray-md-dark" }
const _hoisted_20 = { class: "border text-xs border-next-dark-gray px-2 rounded-sm mr-2" }
const _hoisted_21 = { class: "text-sm border rounded-sm p-1" }
const _hoisted_22 = { class: "ml-2" }
const _hoisted_23 = { class: "xl:col-span-1 lg:col-span-2 flex flex-col pb-3 lg:border-b border-next-gray-md-dark" }
const _hoisted_24 = { class: "flex flex-col pb-3" }
const _hoisted_25 = { class: "flex flex-col pb-3" }
const _hoisted_26 = { class: "flex flex-col pb-3" }
const _hoisted_27 = { class: "flex flex-col pb-3" }
const _hoisted_28 = { class: "flex flex-col pb-3" }
const _hoisted_29 = { class: "flex justify-end mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalFigli = _resolveComponent("ModalFigli")!
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_Field = _resolveComponent("Field")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_MultiselectOption = _resolveComponent("MultiselectOption")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ModalFigli, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event)),
      onAdd: _ctx.addFiglio
    }, null, 8, ["visible", "onAdd"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Breadcrumbs, { paths: _ctx.paths }, null, 8, ["paths"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_NextButton, {
              variant: "outline-secondary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back())),
              class: "w-48 hidden text-sm sm:block py-2 px-4"
            }, {
              default: _withCtx(() => _cache[23] || (_cache[23] = [
                _createTextVNode(" < Indietro ")
              ])),
              _: 1
            })
          ])
        ]),
        _cache[31] || (_cache[31] = _createElementVNode("h3", { class: "text-3xl font-bold mb-3" }, "Nuovo Contatto", -1)),
        (_ctx.permission_denied)
          ? (_openBlock(), _createBlock(_component_Alert, {
              key: 0,
              class: "bg-next-orange mb-5 sticky top-0 z-50"
            }, {
              default: _withCtx(() => _cache[24] || (_cache[24] = [
                _createTextVNode("Non hai i permessi sufficienti per poter creare un contatto ")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Field, {
                  field_name: "Nome",
                  required: true,
                  modelValue: _ctx.contatto_model.nome,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contatto_model.nome) = $event)),
                  errors: _ctx.getErrors('nome')
                }, null, 8, ["modelValue", "errors"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Field, {
                  field_name: "Cognome",
                  required: true,
                  modelValue: _ctx.contatto_model.cognome,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contatto_model.cognome) = $event)),
                  errors: _ctx.getErrors('cognome')
                }, null, 8, ["modelValue", "errors"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_Field, {
                  field_name: "Posizione lavorativa",
                  required: true,
                  modelValue: _ctx.contatto_model.posizione_lavorativa,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.contatto_model.posizione_lavorativa) = $event)),
                  errors: _ctx.getErrors('posizione_lavorativa')
                }, null, 8, ["modelValue", "errors"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_Field, {
                  field_name: "Dipartimento",
                  required: true,
                  modelValue: _ctx.contatto_model.dipartimento,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.contatto_model.dipartimento) = $event)),
                  errors: _ctx.getErrors('dipartimento')
                }, null, 8, ["modelValue", "errors"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_Field, {
                  field_name: "Indirizzo email",
                  required: true,
                  modelValue: _ctx.contatto_model.email,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.contatto_model.email) = $event)),
                  errors: _ctx.getErrors('email')
                }, null, 8, ["modelValue", "errors"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_Field, {
                  field_name: "Metodo di contatto preferito",
                  required: false,
                  modelValue: _ctx.contatto_model.contatto_predefinito,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.contatto_model.contatto_predefinito) = $event)),
                  errors: _ctx.getErrors('contatto_predefinito')
                }, null, 8, ["modelValue", "errors"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_Field, {
                  field_name: "Numeri di telefono",
                  required: false,
                  modelValue: _ctx.contatto_model.telefono_1,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.contatto_model.telefono_1) = $event)),
                  errors: _ctx.getErrors('telefono_1')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.contatto_model.telefono_1) = $event)),
                        placeholder: "Numero telefono",
                        class: "col-span-3 p-2 bg-next-gray-md-dark hover:bg-white"
                      }, null, 512), [
                        [_vModelText, _ctx.contatto_model.telefono_1]
                      ]),
                      _cache[25] || (_cache[25] = _createElementVNode("button", { class: "bg-next-gray-md-dark" }, [
                        _createElementVNode("i", { class: "icon-telefono p-3" })
                      ], -1))
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "errors"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_Field, {
                  field_name: "Numeri di telefono",
                  required: false,
                  "label-class": "invisible",
                  modelValue: _ctx.contatto_model.telefono_2,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.contatto_model.telefono_2) = $event)),
                  errors: _ctx.getErrors('telefono_2')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_17, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.contatto_model.telefono_2) = $event)),
                        placeholder: "Numero telefono",
                        class: "col-span-3 p-2 bg-next-gray-md-dark hover:bg-white"
                      }, null, 512), [
                        [_vModelText, _ctx.contatto_model.telefono_2]
                      ]),
                      _cache[26] || (_cache[26] = _createElementVNode("button", { class: "bg-next-gray-md-dark" }, [
                        _createElementVNode("i", { class: "icon-telefono p-3" })
                      ], -1))
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "errors"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_Field, {
                  field_name: "Gruppo di appartenenza",
                  required: true,
                  modelValue: _ctx.gruppoAutocomplete.selection,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.gruppoAutocomplete.selection) = $event)),
                  errors: _ctx.getErrors('gruppo_contatti_id')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_VueMultiselect, {
                      onSearchChange: _ctx.gruppoAutocomplete.search,
                      loading: _ctx.gruppoAutocomplete.isLoading,
                      options: _ctx.gruppoAutocomplete.options,
                      modelValue: _ctx.gruppoAutocomplete.selection,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.gruppoAutocomplete.selection) = $event)),
                      "track-by": "id",
                      label: "nome",
                      placeholder: "Gruppo",
                      deselectLabel: "Deseleziona",
                      selectedLabel: "Selezionato",
                      selectLabel: "Seleziona",
                      tagPlaceholder: "Aggiungi gruppo",
                      class: "next-vue-multiselect-single"
                    }, {
                      noResult: _withCtx(() => _cache[27] || (_cache[27] = [
                        _createTextVNode("Nessun elemento trovato.")
                      ])),
                      _: 1
                    }, 8, ["onSearchChange", "loading", "options", "modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "errors"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_Field, {
                  field_name: "Account",
                  required: false,
                  modelValue: _ctx.accountAutocomplete.selection,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.accountAutocomplete.selection) = $event)),
                  errors: _ctx.getErrors('accounts')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_VueMultiselect, {
                      modelValue: _ctx.accountAutocomplete.selection,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.accountAutocomplete.selection) = $event)),
                      options: _ctx.accountAutocomplete.options,
                      multiple: true,
                      onSearchChange: _ctx.accountAutocomplete.search,
                      "close-on-select": false,
                      "clear-on-select": false,
                      placeholder: "Accounts",
                      deselectLabel: "Deseleziona",
                      selectedLabel: "Selezionato",
                      selectLabel: "Seleziona",
                      tagPlaceholder: "Aggiungi account",
                      class: "next-vue-multiselect",
                      "track-by": "id",
                      label: "name"
                    }, {
                      noResult: _withCtx(() => _cache[28] || (_cache[28] = [
                        _createTextVNode("Nessun elemento trovato.")
                      ])),
                      tag: _withCtx(({option, remove}) => [
                        _createVNode(_component_MultiselectOption, {
                          onRemove: ($event: any) => (remove(option))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_20, _toDisplayString(option.bu_label || ' '), 1),
                            _createElementVNode("span", null, _toDisplayString(option.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["onRemove"])
                      ]),
                      option: _withCtx(({option}) => [
                        _createElementVNode("span", null, [
                          _createElementVNode("span", _hoisted_21, _toDisplayString(option.bu_label), 1),
                          _createElementVNode("span", _hoisted_22, _toDisplayString(option.name), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "options", "onSearchChange"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "errors"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_Field, {
              field_name: "Note",
              required: false
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.contatto_model.note) = $event)),
                  placeholder: "Note",
                  class: "flex-grow p-5 bg-white"
                }, null, 512), [
                  [_vModelText, _ctx.contatto_model.note]
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_Field, {
              field_name: "Data di nascita",
              modelValue: _ctx.contatto_model.data_di_nascita,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.contatto_model.data_di_nascita) = $event)),
              placeholder: "Data di nascita",
              type: "date",
              errors: _ctx.getErrors('data_di_nascita')
            }, null, 8, ["modelValue", "errors"])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_Field, {
              field_name: "Data ingresso in azienda",
              modelValue: _ctx.contatto_model.data_ingresso_in_azienda,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.contatto_model.data_ingresso_in_azienda) = $event)),
              placeholder: "Data ingresso in azienda",
              type: "date",
              errors: _ctx.getErrors('data_ingresso_in_azienda')
            }, null, 8, ["modelValue", "errors"])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_Field, {
              field_name: "Presente in azienda",
              errors: _ctx.getErrors('presente')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Checkbox, {
                  checkClass: "h-4 w-4",
                  checked: _ctx.contatto_model.presente,
                  onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.contatto_model.presente = !_ctx.contatto_model.presente)),
                  for_id: "pm_esterno"
                }, null, 8, ["checked"])
              ]),
              _: 1
            }, 8, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_Field, {
              field_name: "Stato civile",
              modelValue: _ctx.contatto_model.stato_civile,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.contatto_model.stato_civile) = $event)),
              placeholder: "Stato civile",
              errors: _ctx.getErrors('stato_civile')
            }, null, 8, ["modelValue", "errors"])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_Field, { field_name: "Hobbies e interessi" }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  modelValue: _ctx.hobbiesAutocomplete.selection,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.hobbiesAutocomplete.selection) = $event)),
                  options: _ctx.hobbiesAutocomplete.options,
                  multiple: true,
                  taggable: true,
                  onTag: _cache[22] || (_cache[22] = (value)=>_ctx.hobbiesAutocomplete.add({id:-1, nome:value})),
                  onSearchChange: _ctx.hobbiesAutocomplete.search,
                  "close-on-select": false,
                  "clear-on-select": false,
                  class: "next-vue-multiselect",
                  "track-by": "id",
                  label: "nome",
                  placeholder: "hobby",
                  deselectLabel: "Deseleziona",
                  selectedLabel: "Selezionato",
                  selectLabel: "Seleziona",
                  tagPlaceholder: "Aggiungi hobby"
                }, {
                  tag: _withCtx(({option, remove}) => [
                    _createVNode(_component_MultiselectOption, {
                      onRemove: ($event: any) => (remove(option))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(option.nome), 1)
                      ]),
                      _: 2
                    }, 1032, ["onRemove"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options", "onSearchChange"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_NextButton, {
            variant: "outline-secondary",
            component: "router-link",
            to: {name:'Contatti', params:{id: _ctx.id}},
            class: "w-44 py-2 px-4"
          }, {
            default: _withCtx(() => _cache[29] || (_cache[29] = [
              _createTextVNode(" Annulla ")
            ])),
            _: 1
          }, 8, ["to"]),
          _createVNode(_component_NextButton, {
            variant: "primary",
            onClick: _ctx.save,
            disabled: _ctx.saving,
            class: "w-44 ml-3 py-2 px-4"
          }, {
            default: _withCtx(() => _cache[30] || (_cache[30] = [
              _createTextVNode(" Salva ")
            ])),
            _: 1
          }, 8, ["onClick", "disabled"])
        ])
      ])
    ])
  ], 64))
}